import {unreachableCase} from '~/design-system/utils'
import IconCell from './_components/IconCell'
import TextContentCell from './_components/TextContentCell'
import {TableHead} from '~/design-system/foundations/Table'
import {tableCellVariants} from './variants'
import {type HgTableTitleCellProps} from './types'

const HgTableTitleCellContent = ({className, ...props}: HgTableTitleCellProps) => {
  const getCellContent = () => {
    switch (props.type) {
      case 'icon':
        return <IconCell className={className} {...props} />
      case 'text':
        return <TextContentCell classNames={{content: className}} {...props} />
      case 'empty':
        return null
      default:
        unreachableCase(props)
    }
  }

  return getCellContent()
}

export const HgTableTitleCell = (props: HgTableTitleCellProps) => {
  const {cell, contentWrapper} = tableCellVariants({alignment: props.alignment})

  return (
    <TableHead scope="col" className={cell({className: props.className})}>
      <HgTableTitleCellContent {...props} className={contentWrapper()} />
    </TableHead>
  )
}
